import { useState, useEffect, useRef } from 'preact/compat'

type CallbackFunction = (targetElement: EventTarget) => void

export const useLongPress = (pressed: CallbackFunction = () => {}, release: CallbackFunction = () => {}, ms = 350) => {
  const [startLongPress, setStartLongPress] = useState<boolean>(false)
  const [targetElement, setTargetElement] = useState<EventTarget | null>(null)

  const ref = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (startLongPress) {
      ref.current = setTimeout(() => pressed(targetElement!), ms)
    } else {
      release(targetElement!)
      clearTimeout(ref.current ?? 0)
    }

    return () => {
      clearTimeout(ref.current ?? 0)
      setTargetElement(null)
    }
  }, [startLongPress, pressed, release, ms, targetElement])

  const handleOnPointerDown = () => {
    setStartLongPress(true)
  }

  const handlePointerUp = (event: MouseEvent) => {
    setTargetElement(event.currentTarget)
    setStartLongPress(false)
  }

  const handlePointerLeave = () => {
    setStartLongPress(false)
  }

  const handleOnPointerMove = () => {
    setStartLongPress(false)
  }

  return {
    onPointerDown: handleOnPointerDown,
    onPointerUp: handlePointerUp,
    onPointerLeave: handlePointerLeave,
    onPointerMove: handleOnPointerMove,
  }
}
